export default "__VITE_ASSET__CxYlPXOO__"